import * as React from 'react';
import { CartesianGrid, Legend, Line, LineChart as RLineChart, Tooltip, XAxis, YAxis } from 'recharts';

import { ResponsiveContainer } from '../ResponsiveContainer';

export interface ILineChartProps {
    dataKey: string | string[];
    data: Object[];
    barColors?: string[];
    className?: string;
    customTooltip?: JSX.Element;
    onClick?: Function;
}

export class LineChart extends React.Component<ILineChartProps, {}> {

    render() {
        const { data, dataKey, barColors, onClick, className, customTooltip } = this.props; 
        return (
            <ResponsiveContainer className={className} >
                <RLineChart data={data}
                    onClick={e => e ? (onClick ? onClick(e.activePayload[0].payload) : null) : null}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip content={customTooltip} />
                    <Legend />
                    {barColors.map((dataVal, index) => {
                        return <Line
                            key={index}
                            type="monotone"
                            dataKey={dataKey[index]}
                            stroke={`#${barColors[index]}`}
                            activeDot={{ r: 8 }}
                        />;
                    })}
                </RLineChart>
            </ResponsiveContainer >
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ChartComponents/LineChart/index.tsx